// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailN":"N_wave2DetailN__jfQym"};